"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxField = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
var CheckBoxField = function (props) { return (React.createElement(core_1.Checkbox, { className: props.large ? core_1.Classes.LARGE : '', id: props.id, inline: props.inline, label: props.label, checked: props.checked, disabled: props.disabled, onClick: function (e) { return props.onChange(e.target.checked); } })); };
exports.CheckBoxField = CheckBoxField;
//# sourceMappingURL=CheckboxField.js.map